module.exports = __webpack_public_path__ + "static/media/vodafone.d5aeae4f.jpg";